/**
 * Modal component for displaying generated images
 */

import React from 'react'
import { Modal, Empty } from 'antd'
import { useTranslation } from 'react-i18next'
import ImagePreview from '../../../ImagePreview'

const ImagesModal = ({
  visible,
  onCancel,
  imgArray
}) => {
  const { t } = useTranslation()

  return (
    <Modal
      title="Generated Images"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={1000}
      centered
    >
      <>
        {imgArray && imgArray.length > 0 ? (
          <div className="images-modal__list">
            {imgArray.map((item, index) => (
              <div key={index} className="images-modal__item">
                <h2>Image {index + 1}</h2>
                <ImagePreview src={item} />
              </div>
            ))}
          </div>
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={t('v4:no_image_generated')}
          />
        )}
      </>
    </Modal>
  )
}

export default ImagesModal
